module.exports = __webpack_public_path__ + "img/avatar10.2066022c.jpg";